import t from"../../../../../node_modules/style-inject/dist/style-inject.es.js";var e=".timepicker-container{margin-left:auto;margin-right:auto;max-width:250px}";t(e);export{e as default};
